var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-button',{attrs:{"large":"","color":"green","icon":"fa-file-export","tooltip":_vm.$t('global.crud.buttons.export')},on:{"clicked":function($event){return _vm.doExport()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }